/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Create_Account_HeadingInputs */

const en_login_create_account_heading = /** @type {(inputs: Login_Create_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log in, or create an account`)
};

const id_login_create_account_heading = /** @type {(inputs: Login_Create_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk, atau buat akun`)
};

const ms_login_create_account_heading = /** @type {(inputs: Login_Create_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log masuk, atau buat akaun`)
};

const ca_login_create_account_heading = /** @type {(inputs: Login_Create_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sessió o crea un compte.`)
};

const cs_login_create_account_heading = /** @type {(inputs: Login_Create_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přihlaste se, nebo vytvořte účet`)
};

const da_login_create_account_heading = /** @type {(inputs: Login_Create_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log ind eller opret en konto`)
};

const de_login_create_account_heading = /** @type {(inputs: Login_Create_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melden Sie sich an oder erstellen Sie ein Konto`)
};

const et_login_create_account_heading = /** @type {(inputs: Login_Create_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logige sisse või looge konto`)
};

const es_login_create_account_heading = /** @type {(inputs: Login_Create_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesión o crea una cuenta`)
};

const fr_login_create_account_heading = /** @type {(inputs: Login_Create_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connectez-vous ou créez un compte`)
};

const hr_login_create_account_heading = /** @type {(inputs: Login_Create_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prijavite se ili stvorite račun.`)
};

const it_login_create_account_heading = /** @type {(inputs: Login_Create_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedi o crea un account`)
};

const lv_login_create_account_heading = /** @type {(inputs: Login_Create_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piesakieties vai izveidojiet kontu.`)
};

const lt_login_create_account_heading = /** @type {(inputs: Login_Create_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prisijunkite arba susikurkite paskyrą`)
};

const hu_login_create_account_heading = /** @type {(inputs: Login_Create_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jelentkezzen be, vagy hozzon létre egy fiókot`)
};

const nl_login_create_account_heading = /** @type {(inputs: Login_Create_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log in of maak een account aan`)
};

const nb_login_create_account_heading = /** @type {(inputs: Login_Create_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logg inn eller opprett en konto`)
};

const pl_login_create_account_heading = /** @type {(inputs: Login_Create_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaloguj się lub utwórz konto`)
};

const pt_login_create_account_heading = /** @type {(inputs: Login_Create_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faça login ou crie uma conta.`)
};

const ro_login_create_account_heading = /** @type {(inputs: Login_Create_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectați-vă sau creați un cont`)
};

const sk_login_create_account_heading = /** @type {(inputs: Login_Create_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prihláste sa alebo si vytvorte účet`)
};

const sl_login_create_account_heading = /** @type {(inputs: Login_Create_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prijavite se ali ustvarite račun`)
};

const fi_login_create_account_heading = /** @type {(inputs: Login_Create_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirjaudu sisään tai luo tili.`)
};

const sv_login_create_account_heading = /** @type {(inputs: Login_Create_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logga in, eller skapa ett konto`)
};

const vi_login_create_account_heading = /** @type {(inputs: Login_Create_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đăng nhập, hoặc tạo một tài khoản`)
};

const tr_login_create_account_heading = /** @type {(inputs: Login_Create_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oturum açın veya bir hesap oluşturun`)
};

const el_login_create_account_heading = /** @type {(inputs: Login_Create_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Συνδεθείτε ή δημιουργήστε έναν λογαριασμό`)
};

const bg_login_create_account_heading = /** @type {(inputs: Login_Create_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Влезте или създайте акаунт.`)
};

const ru_login_create_account_heading = /** @type {(inputs: Login_Create_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Войдите в систему или создайте аккаунт.`)
};

const sr_login_create_account_heading = /** @type {(inputs: Login_Create_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пријавите се, или креирајте налог`)
};

const uk_login_create_account_heading = /** @type {(inputs: Login_Create_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Увійдіть або створіть обліковий запис`)
};

const ka_login_create_account_heading = /** @type {(inputs: Login_Create_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`შედით ან შექმენით ანგარიში.`)
};

const hi_login_create_account_heading = /** @type {(inputs: Login_Create_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लॉग इन करें, या एक खाता बनाएं`)
};

const th_login_create_account_heading = /** @type {(inputs: Login_Create_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เข้าสู่ระบบหรือสร้างบัญชี`)
};

const ko_login_create_account_heading = /** @type {(inputs: Login_Create_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로그인 또는 계정 만들기`)
};

const zh_login_create_account_heading = /** @type {(inputs: Login_Create_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录或创建账户`)
};

const zh_tw_login_create_account_heading = /** @type {(inputs: Login_Create_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登入或建立帳戶`)
};

const ja_login_create_account_heading = /** @type {(inputs: Login_Create_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ログインまたはアカウントを作成`)
};

/**
* | output |
* | --- |
* | "Log in, or create an account" |
*
* @param {Login_Create_Account_HeadingInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const login_create_account_heading = /** @type {((inputs?: Login_Create_Account_HeadingInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Create_Account_HeadingInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_login_create_account_heading(inputs)
	if (locale === "ms") return ms_login_create_account_heading(inputs)
	if (locale === "ca") return ca_login_create_account_heading(inputs)
	if (locale === "cs") return cs_login_create_account_heading(inputs)
	if (locale === "da") return da_login_create_account_heading(inputs)
	if (locale === "de") return de_login_create_account_heading(inputs)
	if (locale === "et") return et_login_create_account_heading(inputs)
	if (locale === "es") return es_login_create_account_heading(inputs)
	if (locale === "fr") return fr_login_create_account_heading(inputs)
	if (locale === "hr") return hr_login_create_account_heading(inputs)
	if (locale === "it") return it_login_create_account_heading(inputs)
	if (locale === "lv") return lv_login_create_account_heading(inputs)
	if (locale === "lt") return lt_login_create_account_heading(inputs)
	if (locale === "hu") return hu_login_create_account_heading(inputs)
	if (locale === "nl") return nl_login_create_account_heading(inputs)
	if (locale === "nb") return nb_login_create_account_heading(inputs)
	if (locale === "pl") return pl_login_create_account_heading(inputs)
	if (locale === "pt") return pt_login_create_account_heading(inputs)
	if (locale === "ro") return ro_login_create_account_heading(inputs)
	if (locale === "sk") return sk_login_create_account_heading(inputs)
	if (locale === "sl") return sl_login_create_account_heading(inputs)
	if (locale === "fi") return fi_login_create_account_heading(inputs)
	if (locale === "sv") return sv_login_create_account_heading(inputs)
	if (locale === "vi") return vi_login_create_account_heading(inputs)
	if (locale === "tr") return tr_login_create_account_heading(inputs)
	if (locale === "el") return el_login_create_account_heading(inputs)
	if (locale === "bg") return bg_login_create_account_heading(inputs)
	if (locale === "ru") return ru_login_create_account_heading(inputs)
	if (locale === "sr") return sr_login_create_account_heading(inputs)
	if (locale === "uk") return uk_login_create_account_heading(inputs)
	if (locale === "ka") return ka_login_create_account_heading(inputs)
	if (locale === "hi") return hi_login_create_account_heading(inputs)
	if (locale === "th") return th_login_create_account_heading(inputs)
	if (locale === "ko") return ko_login_create_account_heading(inputs)
	if (locale === "zh") return zh_login_create_account_heading(inputs)
	if (locale === "zh-tw") return zh_tw_login_create_account_heading(inputs)
	if (locale === "ja") return ja_login_create_account_heading(inputs)
	return en_login_create_account_heading(inputs)
});